import { getToken } from "./user-service";
export const postTester = async (tester) => {
  return new Promise(async (resolve, reject) => {
    const token = await gettoken();
    try {
      const response = await fetch("/api/v1/support/testers", {
        method: "POST",
        body: JSON.stringify(tester),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "Firebase-UID": token,
        },
      });
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error(json);
      }
      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};
